import { X } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

import { SelectionBarProps } from '../types';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function SelectionBar({ selectedCount, actions, onClose, className }: SelectionBarProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 flex justify-center pb-10 z-50 pointer-events-none">
      <div
        className={cn(
          'flex flex-row justify-center items-center',
          'px-6 py-4 gap-4 sm:gap-20',
          'max-w-5xl w-auto mx-4',
          'bg-white dark:bg-gray-950 rounded-lg',
          'border border-zinc-200 dark:border-zinc-800',
          'shadow-lg',
          'animate-in slide-in-from-bottom-5 duration-200',
          'pointer-events-auto',
          className
        )}>
        <div className="flex items-center gap-4">
          <span className="text-sm font-medium whitespace-nowrap">
            {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
          </span>
          {onClose && (
            <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8">
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>

        <div className="flex items-center gap-2 justify-end">
          {actions.map((action) => (
            <Tooltip key={action.id}>
              <TooltipTrigger asChild>
                <Button
                  variant={action.variant}
                  onClick={action.onClick}
                  disabled={action.disabled}
                  size="sm"
                  className="gap-2">
                  {action.icon}
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>{action.label}</p>
              </TooltipContent>
            </Tooltip>
          ))}
        </div>
      </div>
    </div>
  );
}
